import React, {useEffect, useState} from "react";
import ShopOrderTooltipHeaderNav from "./tooltips/ShopOrderTooltipHeaderNav";
import {
    DETAILS_TAB,
    INVOICE_TAB,
    ISSUES_TAB,
    LINE_ITEMS_TAB,
    NOTES_TAB,
    SERVICES_TAB,
    TRANSACTIONS_TAB
} from "../../constants/orders";
import DetailsTab from "./tooltips/DetailsTab";
import ServicesTab from "./tooltips/ServicesTab";
import NotesTab from "./tooltips/NotesTab";
import IssuesTab from "./tooltips/IssuesTab";
import InvoiceTab from "./tooltips/InvoiceTab";
import TransactionsTab from "./tooltips/TransactionsTab";
import InvoiceAiMappingTab from "./tooltips/InvoiceAiMappingTab";
import {connect} from "react-redux";
import {Loader} from "semantic-ui-react";

function ShopOrderDetails({dispatch, id, isLoading, order, customer, tabData}) {
    useEffect(() => {
            dispatch({
                type: 'SHOP_ORDER_LOAD_SAGA',
                payload: {id: id, showLoading: !order}
            })
    }, [])

    const [activeTab, setActiveTab] = useState(DETAILS_TAB)
    const [invoiceMappingUpdates, setInvoiceMappingUpdates] = useState({})

    const switchTab = (tab) => {
        setActiveTab(tab)
    }

    const updateOrder = (payload) => {
        dispatch({
            type: 'SHOP_ORDERS_UPDATE_SAGA',
            payload: {id: order.id, ...payload}
        })
    }

    const handleRefund = (payload, successCallback) => {
        dispatch({
            type: 'SHOP_ORDERS_REFUND_SAGA',
            payload: payload,
            successCallback: successCallback
        })
    }

    const handleResolution = () => {
        dispatch({
            type: 'SHOP_ORDERS_RESOLUTION_SAGA',
            payload: {id: order.id},
        })
    }

    const onSaveMapping = (event, data, invoiceItem) => {
        let invoiceMapping = {...invoiceMappingUpdates}
        invoiceMapping[invoiceItem] = data.value
        setInvoiceMappingUpdates(invoiceMappingUpdates)
    }

    const updateMappings = () => {
        let mappings = []
        let invoiceMapping = {...invoiceMappingUpdates}
        Object.keys(invoiceMapping).forEach((key) =>
            mappings.push({
                ai_desc: invoiceMapping[key],
                invoice_desc: key,
                company_id: order.shop.company_id
            })
        )
        this.props.dispatch({
            type: 'MAPPING_CREATE_OR_UPDATE_SAGA',
            payload: mappings
        })
    }

    return (
        <>
            {isLoading && <Loader active={isLoading}/>}

            {!isLoading && order && (<>
                <ShopOrderTooltipHeaderNav
                    activeTab={activeTab}
                    switchTab={switchTab}
                    tabData={tabData}
                    order={order}
                />

                {activeTab === DETAILS_TAB &&
                    <DetailsTab
                        customer={customer}
                        vehicle={order.vehicle}
                        shop={order.shop}
                        localAppointmentDatetime={order.local_appointment_datetime}
                    />
                }
                {activeTab === SERVICES_TAB &&
                    <ServicesTab order={order} orderServices={order.order_services} updateOrder={updateOrder}/>
                }
                {activeTab === NOTES_TAB &&
                    <NotesTab internalNotes={order.internal_notes} updateOrder={updateOrder}/>
                }
                {activeTab === ISSUES_TAB &&
                    <IssuesTab orderIssue={order.order_issue} updateOrder={updateOrder}/>
                }
                {activeTab === INVOICE_TAB &&
                    <InvoiceTab
                        order={order}
                        handleRefund={handleRefund}
                        handleResolution={handleResolution}
                    />
                }
                {activeTab === TRANSACTIONS_TAB &&
                    <TransactionsTab order={order} handleRefund={handleRefund}/>
                }
                {activeTab === LINE_ITEMS_TAB &&
                    <InvoiceAiMappingTab
                        order={order}
                        onSaveMapping={onSaveMapping}
                        onSubmitMapping={updateMappings}
                    />
                }
            </>)}
        </>
    )
}

const mapStateToProps = (state, props) => {
    const orderDetails = state.shopOrders && state.shopOrders.orderDetails;
    return {
        order: orderDetails && orderDetails[props.id] ? orderDetails[props.id] : null,
        isLoading: state.application.isTooltipLoading
    }
}

export default connect(mapStateToProps)(ShopOrderDetails)
